exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-0f897286]{color:#817f7f}", ""]);

// exports
